import "./styles.scss";

import { useTranslation } from "react-i18next";

import { ReactComponent as ErrorIcon } from "assets/icons/new/error.svg";
import { ReactComponent as MastercardIcon } from "assets/icons/mastercard.svg";
import { ReactComponent as VisaIcon } from "assets/icons/visa.svg";

const mainClass = "details-card__payment-error";

const PaymentError = ({ items }) => {
  const { t } = useTranslation();
  const paymentMethod = items?.find((item) => item?.type === "card");
  const cardType = paymentMethod?.value?.card_type?.toLowerCase();

  const cardBrand = {
    mastercard: {
      icon: <MastercardIcon />,
      label: "MasterCard",
    },
    visa: {
      icon: <VisaIcon />,
      label: "Visa",
    },
  }[cardType];

  return (
    <div className={mainClass}>
      <div className={`${mainClass}__method`}>
        <span>{paymentMethod?.label}</span>
        <div className={`${mainClass}__card`}>
          {cardBrand && (
            <div className={`${mainClass}__brand`}>
              {cardBrand.icon}
              <span>{cardBrand.label}</span>
            </div>
          )}
          <span>{paymentMethod?.value?.card_numbers}</span>
        </div>
      </div>
      <div className={`${mainClass}__message`}>
        <strong>
          <ErrorIcon />
          {t("Verify the payment method")}
        </strong>
        <span>
        {t(
            "There was a problem processing your payment. Check your payment information and try again",
        )}
        </span>
      </div>
    </div>
  );
};

export default PaymentError;
